<script>
import { mapGetters } from "vuex";
import {formatCompact} from "@/shared/utils/formatters";

export default {
  data: function () {
    return {
      multinationalOrganizations: {},
    };
  },
  computed: { ...mapGetters(["getTrackerMultinationalOrganizations"]) },
  watch: {
    getTrackerMultinationalOrganizations: {
      handler() {
        this.formatMultinational();
      },
      deep: true,
    },
  },
  mounted() {
    this.formatMultinational();
  },
  methods: {
    formatCompact,
    formattedPercentage: (percentage) => {
      return (+percentage ?? 0).toFixed(0) + "%";
    },
    formatMultinational: function () {
      var yes =
        this.getTrackerMultinationalOrganizations.data.find((org) => org._id === 'label_tracker_multinational_yes')
          ?.count ?? 0;
      var no =
        this.getTrackerMultinationalOrganizations.data.find((org) =>  org._id === 'label_tracker_multinational_no')
          ?.count ?? 0;
      var total = yes + no;
      this.multinationalOrganizations = {
        yes: yes,
        percentageYes: this.formattedPercentage(
          total > 0 ? (100 * yes) / total : 0
        ),
        no: no,
        percentageNo: this.formattedPercentage(
          total > 0 ? (100 * no) / total : 0
        ),
      };
    },
  },
};
</script>

<template>
<!--  <div v-if="store.isLoading" class="loading">
    <VueSpinner size="20"
color="#213a7a" />
  </div>-->

  <div
    class="public-institutions-providing-direct-services"
    style="cursor: pointer"

  >
    <div class="public-data">
      <div class="public-yes">
        {{
          $t(
            "label_dashboard_multinational_organization_yes"
          )
        }}
      </div>
      <div class="public-total">
        {{ formatCompact(multinationalOrganizations?.yes) }}
      </div>
      <div class="public-percentage">
        {{ (multinationalOrganizations.percentageYes) }}
      </div>
    </div>
    <div class="public-yes-no">

      <div class="public-divider" />

    </div>
    <div class="public-data">
      <div class="public-no">
        {{
          $t("label_dashboard_multinational_organization_no")
        }}
      </div>

      <div class="public-total">
        {{ formatCompact(multinationalOrganizations?.no) }}
      </div>

      <div class="public-percentage">
        {{ (multinationalOrganizations?.percentageNo) }}
      </div>

    </div>
  </div>
</template>

<style scoped>
.public-institutions-providing-direct-services {
  display: flex;
  justify-content: center;
  gap: 30px;
  height: 100%;
}

.public-yes-no {
  display: flex;
  align-items: center;
  gap: 20px;
}

.public-percentage {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 15px;
  font-family: Montserrat, sans-serif;
  color: #2f60a6;
}

.public-total {
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  color: #2f60a6;
}

.public-divider {
  height: 110px;
  background-color: #ebece4;
  width: 2px;
}

.public-yes {
  /*  writing-mode: vertical-lr;*/
  font-size: 38px;
  font-family: Montserrat, sans-serif;
  color: #4fa62f;
  /* transform: rotateZ(180deg);*/
}

.public-no {
  /*  writing-mode: vertical-lr;*/
  font-size: 38px;
  font-family: Montserrat, sans-serif;
  color: #be003c;
  /*  transform: rotateZ(180deg);*/
}

.public-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading {
  height: 135px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.public-institutions-providing-direct-services-modal-container {
  .public-yes,
  .public-no {
    font-size: 13vw;
  }
  .public-total {
    font-size: 6vw;
  }
  .public-percentage {
    font-size: 4.6vw;
  }
  .public-divider {
    height: 50vh;
  }
}
</style>
